<template>
    <v-container fluid>
        <newStateModal :newStateDialog.sync="newStateDialog" :deviceId="deviceId" :device="device" @update-device="updateDevice"></newStateModal>
        <irrigationOrderModal :deviceId="deviceId" :device="device" :irrigationOrderDialog.sync="irrigationOrderDialog"></irrigationOrderModal>
        <v-speed-dial
            class="device-actions-btn"
            v-model="fab"
            bottom
            right
            direction='top'
            transition='slide-y-reverse-transition'
        >
            <template v-slot:activator>
                <v-btn
                v-model="fab"
                color="#0098E1"
                dark
                fab
                >
                <v-icon size="40" v-if="fab">close</v-icon>
                <v-icon size="40" v-else>add</v-icon>
                </v-btn>
            </template>

            <v-btn
                id = "irrigationOrders"
                fab 
                dark
                small
                color="white"
                @click.stop="openIrrigationOrderModal()"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" d="M24 0H0v24h24V0zm0 0H0v24h24V0zM0 24h24V0H0v24z"/><path fill="#0098E1" d="M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"/>
                </svg>
            </v-btn>
            <v-btn
                id = "newState"
                fab
                dark
                small
                color="white"
                @click.stop="openNewStateModal()"
            >
                <v-icon color="#0098E1">update</v-icon>
            </v-btn>
        </v-speed-dial>
    </v-container>
</template>
<script>
const NewStateModal = () => import('./Modal/NewStateModal.vue');
const IrrigationOrderModal = () => import('./Modal/IrrigationOrderModal.vue');

export default{
  data () {
    return {
      newStateDialog: false,
      irrigationOrderDialog: false,
      fab: false
    };
  },
  props: {
    device: {
      type: Object
    },
    deviceId: {
      type: String
    }
  },
  methods: {
    openNewStateModal () {
      mixpanel.track('Click new state button');
      gtag('event', 'click_new_state_button', {event_category: 'click', event_label: 'Click new state button'});
      this.newStateDialog = true;
      this.fab = false;
    },
    openIrrigationOrderModal () {
      mixpanel.track('Click irrigation order button');
      gtag('event', 'click_irrigation_order_button', {event_category: 'click', event_label: 'Click irrigation order button'});
      this.irrigationOrderDialog = true;
      this.fab = false;
    },
    updateDevice () {
      this.$emit('reload-device');
    }
  },
  components: {
    'newStateModal': NewStateModal,
    'irrigationOrderModal': IrrigationOrderModal
  }
};
</script>


// WEBPACK FOOTER //
// DeviceActions.vue?4b722a32